import { agentFragment } from './fragmentsAgent';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const agentActivateMutationAtom = createMutationAtomFactory(
  'admin.agentActivate',
  (params: { id: string }) => ({
    assistantActivateAgent: {
      __args: {
        id: params.id,
      },
      ...agentFragment,
    },
  }),
);

export const agentDeactivateMutationAtom = createMutationAtomFactory(
  'admin.agentDeactivate',
  (params: { id: string }) => ({
    assistantDeactivateAgent: {
      __args: {
        id: params.id,
      },
      ...agentFragment,
    },
  }),
);
